/**
 * Import des librairies utilisées par toute l'appli
 */
import 'vuetify/dist/vuetify.min.css'; // Ensure you are using css-loader
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Router from 'vue-router';
import Vuelidate from 'vuelidate';
import Toasted from 'vue-toasted';
import VueResource from 'vue-resource';
import Errors from './errors';
import Auth from './auth';
import Api from './api';
import Liens from './liens';
import Visible from './directives/visible';
import ParametreEnumDialog from '@/components/administration';
import Breadcrumb from '@/components/breadcrumb';
import Crud from '@/components/crud';
import Commun from '@/components/commun';
import Dropdown from '@/components/dropdown';
import EnumEntityField from '@/components/enumEntity';
import ManyToOne from '@/components/many-to-one';
import NavBar from '@/components/navBar';
import Table from '@/components/table';
import CritereElement from '@/components/CriteresRecherche';
import Export from '@/components/export';
import Envoi from '@/components/envoi';
import Telephone from '@/components/telephone';
import Adresse from '@/components/adresse';
import PersonneMorale from '@/components/personnemorale';
import PersonnePhysique from '@/components/personnephysique';
import Participant from '@/components/participant';
import Instance from '@/components/instance';
import VueMask from 'vue-the-mask';
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';

import '@/store';

Vue.use(VueI18n);
Vue.use(Router);
Vue.use(Vuelidate);
Vue.use(Toasted, {
  duration: 4000,
});
Vue.use(Auth);
Vue.use(Api);
Vue.use(Visible);
Vue.use(Liens);
Vue.use(VueResource);
Vue.use(Errors);
Vue.use(Crud);
Vue.use(Breadcrumb);
Vue.use(Table);
Vue.use(ManyToOne);
Vue.use(NavBar);
Vue.use(CritereElement);
Vue.use(Export);
Vue.use(Envoi);
Vue.use(Telephone);
Vue.use(Adresse);
Vue.use(PersonneMorale);
Vue.use(PersonnePhysique);
Vue.use(Participant);
Vue.use(Instance);
Vue.use(Commun);
Vue.use(Dropdown);
Vue.use(EnumEntityField);
Vue.use(ParametreEnumDialog);
Vue.use(VueMask);
Vue.use(VueTelInputVuetify);
